import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {Hall} from 'vexpo-components';

/** @class HallPreview
  * A component for rendering a preview of
  * a hall being edited.
  * @prop {string} dataURL - the url of the hall being edited
  */
export default class HallPreview extends Component {
  /** @constructor
    * Creates a new instance of HallPreview
    */
  constructor(props) {
    super(props);
    this.state = {
      hall: {
        hallID: 0,
        name: "Loading Hall...",
        booths: [],
        stage: {
          width: 0,
          height: 0,
          identifier: "loading hall",
          layers: []
        }
      }
    }
    this.dataURL = `/expos/${this.props.expoID}/shows/${this.props.showID}/halls/${this.props.hallID}`;
    this.dataRef = firebase.database().ref(this.dataURL);
  }
  /** @method componentWillMount
    * Connects the component to the firebase record for the hall.
    */
  componentWillMount() {
    this.dataRef.on('value', (snapshot) => {
      var key;
      const data = snapshot.val();
      var hall = {
        name: data.name,
        hallID: snapshot.key,
        stage: {
          width: data.stage.width,
          height: data.stage.height,
          layers: []
        }
      }
      // Convert layer representation from object to sorted array
      for(key in data.stage.layers) {
        var layer = data.stage.layers[key];
        hall.stage.layers.push(layer);
      }
      hall.stage.layers = hall.stage.layers.sort((a,b) => {return a.order - b.order});
      // Add the booths
      var icons = []
      for(key in data.booths) {
        icons.push(data.booths[key]);
      }
      hall.stage.layers.push({
        type: 'icons',
        icons: icons
      });
      this.setState({hall: hall});
    });
  }
  /** @method componentWillUnmount
    * Disconnects the component from firebase
    */
  componentWillUnmount() {
    this.dataRef.off();
  }
  /** @method render
    * Renders the hall
    */
  render() {
    return <Hall {...this.state.hall} editorPreview={true}/>
  }
}



// WEBPACK FOOTER //
// ./src/hall-preview/hall-preview.js